import React, { useState } from 'react';
import axios from 'axios';
import { FaDownload, FaDatabase, FaFileArchive } from 'react-icons/fa';
import { API_ENDPOINTS } from '../../config/api';
import '../../styles/AdminDataDownload.css';

const AdminDataDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      setError('');
      setMessage('Preparing your company export...');

      const token = sessionStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.LAB_ADMIN_DATA_EXPORT, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'company_data.zip');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setMessage('Download started: company_data.zip');
    } catch (err) {
      const apiMessage = err?.response?.data?.message;
      setError(apiMessage || 'Failed to download company data. Please try again.');
      setMessage('');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="section-content admin-data-download-section">
      <div className="section-header">
        <h1>Download Your Data</h1>
        <p>Export your company records and your admin data as a ZIP archive.</p>
      </div>

      {error ? <div className="alert alert-error"><strong>Error:</strong> {error}</div> : null}
      {message ? <div className="alert alert-success"><strong>Status:</strong> {message}</div> : null}

      <div className="download-data-card">
        <div className="download-data-head">
          <div className="icon-wrap">
            <FaDatabase />
          </div>
          <div>
            <h2>Company Export Package</h2>
            <p>Only admins can download data, and only for their own company.</p>
          </div>
        </div>

        <div className="download-data-list">
          <div><FaFileArchive /> company.json</div>
          <div><FaFileArchive /> users.csv</div>
          <div><FaFileArchive /> assets.csv</div>
          <div><FaFileArchive /> assignments.csv</div>
          <div><FaFileArchive /> maintenance.csv</div>
          <div><FaFileArchive /> logs.json</div>
          <div><FaFileArchive /> documents/* (available images/files)</div>
        </div>

        <button
          type="button"
          className="download-data-btn"
          onClick={handleDownload}
          disabled={isDownloading}
        >
          <FaDownload /> {isDownloading ? 'Preparing ZIP...' : 'Download company_data.zip'}
        </button>
      </div>
    </div>
  );
};

export default AdminDataDownload;
